import axios from "axios";
import { useMutation, useQueryClient } from "react-query";
import { useGenErrorMsgBanners } from "../../../utils/useGenErrorMsgBanners";

export const useQuickUpdateContent = () => {
  const { genErrorMsgBanners } = useGenErrorMsgBanners();
  const queryClient = useQueryClient();
  return useMutation(
    ({
      contentType,
      contentId,
      body,
      onInvalidateQueriesSuccess,
      onInvalidateQueriesError,
      skipCreateChunksProducer = false /* used by annotation-edit pipeline on a published doc — chunks ignore mark nodes, so re-chunking on an annotation-only edit is wasted work */,
    }) => {
      const params = new URLSearchParams();
      if (skipCreateChunksProducer) params.set("skipCreateChunksProducer", "true");
      const query = params.toString() ? `?${params.toString()}` : "";
      return axios.post(
        `/api/content/quickUpdateContent/${contentType}/${contentId}${query}`,
        body,
        { headers: { "Content-Type": "application/json" } }
      );
    },
    {
      onError: (err) => {
        genErrorMsgBanners({ err });
      },
      onSuccess: (
        res,
        { contentType, onInvalidateQueriesError, onInvalidateQueriesSuccess }
      ) => {
        queryClient
          .invalidateQueries(["contentListing", "lazy", [contentType]])
          .then(() => {
            onInvalidateQueriesSuccess && onInvalidateQueriesSuccess();
          })
          .catch(() => {
            onInvalidateQueriesError && onInvalidateQueriesError();
          });
      },
    }
  );
};
